import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { combineReducers, StoreModule } from '@ngrx/store';

import { solarPanelsReducers, solarPanelsSelectorKey } from './store';
import { SolarPanelsFunnelEffects } from './store/solar-panels-funnel/solar-panels-funnel.effects';
import { SolarPanelsWizardEffects } from './store/solar-panels-wizard/solar-panels-wizard.effects';
import { SolarPanelsOrderFormEffects } from './store/solar-panels-order-form/solar-panels-order-form.effects';
import { SolarPanelsResultOverviewEffects } from './store/solar-panels-result-overview/solar-panels-result-overview.effects';
import { SolarPanelsProductOverviewEffects } from './store/solar-panels-products/solar-panels-product-overview.effects';
import { SolarPanelsSuitabilityCheckEffects } from './store/solar-panels-suitability-check/solar-panels-suitability-check.effects';
import { SolarPanelsUsageQuestionnaireFormSubmitEffects } from './store/usage-questionnaire-modal/usage-questionnaire-form-submit.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(
      solarPanelsSelectorKey,
      combineReducers(solarPanelsReducers)
    ),
    EffectsModule.forFeature([
      SolarPanelsFunnelEffects,
      SolarPanelsWizardEffects,
      SolarPanelsOrderFormEffects,
      SolarPanelsResultOverviewEffects,
      SolarPanelsProductOverviewEffects,
      SolarPanelsSuitabilityCheckEffects,
      SolarPanelsUsageQuestionnaireFormSubmitEffects,
    ]),
  ],
})
export class SolarPanelsBootstrapModule {}
